import React from "react";
import { useNavigate } from "react-router-dom";
import { thunk_reset_user } from '../../../src/Action/action';
import { connect } from 'react-redux';

const AuthorizeComponent = ({ dispatch }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(thunk_reset_user({}));
    navigate("/");
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f1f3f5'
    }}>
      <div style={{
        maxWidth: '500px',
        width: '100%',
        background: '#fff',
        padding: '40px 30px',
        borderRadius: '16px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
        textAlign: 'center'
      }}>
        <img
          src="https://cdn-icons-png.flaticon.com/512/565/565547.png"
          alt="Not Authorized"
          style={{ width: 100, marginBottom: 20 }}
        />
        <h2>You are not authorized</h2>
        <p style={{ color: '#6c757d', marginBottom: 30 }}>
          You don’t have permission to access this page.<br />
          Try signing in with a different account.
        </p>

        <div style={{ display: 'flex', justifyContent: 'center', gap: 20 }}>
          <button
            onClick={handleLogout}
            style={{
              background: '#dc3545',
              color: '#fff',
              border: 'none',
              padding: '10px 20px',
              borderRadius: 8,
              cursor: 'pointer',
              fontWeight: 600
            }}
          >
            Logout
          </button>
          <a
            href="/dashboard"
            style={{
              background: '#007bff',
              color: '#fff',
              padding: '10px 20px',
              borderRadius: 8,
              textDecoration: 'none',
              fontWeight: 600
            }}
          >
            Go to Dashboard
          </a>
        </div>
      </div>
    </div>
  );
};

export default connect()(AuthorizeComponent);
